import { makeStyles } from '@mui/styles'
import { createTheme } from '@mui/styles'
export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1),
    width: '70% !important',
    ['@media only screen and (max-width: 600px)']: {
      width: '100% !important',
    },
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 24,
    ['@media only screen and (max-width: 600px)']: {
      fontSize: '18px',
    },
  },
  subTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    textAlign: 'justify',
    marginBottom: '2% !important',
    ['@media only screen and (max-width: 600px)']: {
      fontSize: '16px',
    },
  },
  subTitleWait: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 19,
    color: '#58585A',
    // marginTop: '1% !important',
    marginBottom: '1% !important',
    ['@media only screen and (max-width: 600px)']: {
      marginTop: '1% !important',
      marginBottom: '4% !important',
      fontSize: '16px',
    },
  },

  titleEstatus: {
    alignSelf: 'flex-start',
    fontWeight: 'bold',
    // fontWeight: 'bold',
    // alignItems: 'center',
    // justifyContent: 'center',
    // fontSize: 20,
    // marginTop: theme.spacing(2),
    color: '#7DC133'
  },
  margin: {
    margin: theme.spacing(1),
  },
  topImage: {
    padding: theme.spacing(1),
  },
  captionRegister: {
    width: '100% !important',
  },
  wc100: {
    width: '100% !important',
  },
  pc12: {
    padding: '12px !important',
  },
  tAgCenter: {
    textAlign: 'center'
  },
  colContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  passBtn: {
    display: 'flex',
    //outline: 'solid 1px tomato !important',
    width: '100% !important',
    justifyContent: 'flex-end'
  },
  loginButton: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(4)
  },
  devicePicContainer: {
    marginTop: '40px',
    textAlign: 'center',
  },
  ButtonEnabled: {
    // marginTop: theme.spacing(3),
    // margin: theme.spacing(0.5),
    // marginBottom: '15px !important'
  },
  ButtonDisabled: {
    // marginTop: theme.spacing(3),
    // margin: theme.spacing(0.5),
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important',
    marginBottom: '15px !important'
  },
  rootPINCT: {
    margin: '2px !important'
  },
  classNamelabel: {
    letterSpacing: '0px !important',
  },
  buttonWidths: {
    width: '100% !important',
    textAlign: 'center !important',
  },
  imgPin: {
    [theme.breakpoints.only('xs')]: {
      width: '35% !important',
    },
    [theme.breakpoints.only('sm')]: {
      width: '60% !important',
    },
    [theme.breakpoints.only('md')]: {
      width: '60% !important',
    },
    [theme.breakpoints.only('lg')]: {
      width: '35% !important',
    },
    [theme.breakpoints.only('xl')]: {
      width: '45% !important',
    },
  },
}))
